import { Component } from '@angular/core';
import { Router } from '@angular/router';
//Servicios
import { ConfigService } from './servicios/config/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  getUsuarioid  : any = localStorage.getItem('usuarioid');
  mostrarlogin  : boolean = false;
  logout        : any = localStorage.getItem('logout');

  title = 'Refrigerar';

  listpermisos : any;
  mostrarpreloaderpri  : any = 1;

  constructor(
    private router        : Router,
    private configService : ConfigService
  ) {}

  ngOnInit()
  {
    if (this.getUsuarioid) {
      //Validación que usa un parametro de logueo solo una vez al momento de loguearse al aplicativo
      //con el fin de redireccionar al modulo dashboard
      if (this.logout) {
        this.mostrarlogin = false;
        this.router.navigate(['main/dashboard'], { replaceUrl: true });
        localStorage.removeItem('logout');
      } else {
        this.mostrarlogin = false;
      }
    } else {
      this.mostrarlogin = true;
    }
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/app.component.ts